import PropTypes from 'prop-types';
import React from 'react';

import NormalButton from '../../atoms/NormalButton';

class UserEditButton extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.any,
      onClick: PropTypes.func,
    };
  }

  render() {
    return (
      <NormalButton color="warning" onClick={this.props.onClick}>
        編集
      </NormalButton>
    );
  }
}

export default UserEditButton;
